export function padData(spectraData, options) {
    const { minX, maxX, minY, maxY } = spectraData;
    const width = options.width;
    const nbPoints = spectraData.z[0].length;
    const nbSubSpectra = spectraData.z.length;
    const yInterval = (maxY - minY) / (nbSubSpectra - 1);
    const xInterval = (maxX - minX) / (nbPoints - 1);
    let yDiff = width - nbSubSpectra;
    let xDiff = Math.max(width - nbPoints, 0);
    if (xDiff % 2)
        xDiff++;
    if (yDiff % 2)
        yDiff++;
    const xOffset = xDiff / 2;
    const yOffset = yDiff / 2;
    const newMatrix = [];
    for (let i = 0; i < nbSubSpectra + yDiff; i++) {
        newMatrix.push(new Float64Array(nbPoints + xDiff));
    }
    for (let i = 0; i < nbSubSpectra; i++) {
        for (let j = 0; j < nbPoints; j++) {
            newMatrix[i + yOffset].set(spectraData.z[i], xOffset);
        }
    }
    return {
        ...spectraData,
        z: newMatrix,
        minX: minX - xOffset * xInterval,
        maxX: maxX + xOffset * xInterval,
        minY: minY - yOffset * yInterval,
        maxY: maxY + yOffset * yInterval,
    };
}
//# sourceMappingURL=padData.js.map